//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class LogicalExpressionModel extends ModelBase {
      static readonly $typeName = 'LogicalExpressionModel';
      public key: string;
      public hashCode: string;
      public propertyKey: string;
      public groupName: string;
      public operationName: string;
      public operatorName: string;
      public order: number;
      public value: string;
      public valueVocabulary: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/LogicalExpressionModel.ts